import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { KineticLines, Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";

export default function SeasonEditorial() {
  return (
    <section className="grain relative overflow-hidden bg-orange-rific py-16 text-deep md:py-24" data-testid="season-editorial-section">
      <div className="relative mx-auto grid max-w-[1440px] items-center gap-12 px-5 md:px-10 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-deep/70 md:text-xs">The RIFIC Philosophy</p>
          </Reveal>
          <KineticLines
            lines={["TASTE HAS", "A SEASON."]}
            className="mt-4 block"
            lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-deep"
          />
          <Reveal delay={0.2}>
            <p className="mt-7 max-w-md text-base leading-relaxed text-deep/85 md:text-lg">
              Some flavours shouldn't be rushed.
            </p>
            <p className="mt-3 max-w-md text-base leading-relaxed text-deep/85 md:text-lg">
              When fruit is at its best, that's when we want it in your scoop.
            </p>
            <Link
              to="/our-story"
              data-testid="season-read-story-cta"
              className="mt-8 inline-flex h-12 items-center gap-2 rounded-full border-2 border-deep px-7 text-xs font-bold uppercase tracking-[0.16em] text-deep transition-colors duration-300 hover:bg-deep hover:text-cream"
            >
              Read Our Story
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6">
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-3xl bg-cream">
              <img
                src={IMG.ripe.alphonso}
                alt="RIFIC Alphonso mango ice cream with fresh mango cubes"
                loading="lazy"
                className="h-auto w-full object-contain"
              />
            </div>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="mt-8 overflow-hidden rounded-3xl bg-cream md:mt-14">
              <img
                src={IMG.ripe.strawberry}
                alt="RIFIC strawberry ice cream with fresh strawberries"
                loading="lazy"
                className="h-auto w-full object-contain"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
